module.exports = __webpack_public_path__ + "img/payback_script.e2fab801.svg";